import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import ExpandableItem from './ExpandbleItem'
import SingleIntem from './SingleItem'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import MenuIcon from '@material-ui/icons/Menu'
import { ReactComponent as HomeIcon } from 'assets/icons/ic-home-new.svg'
import _get from 'lodash/get'
import {
  StyledListItem,
  StyledListItemText
} from './styles'

function ItemsList ({
  items,
  menuState,
  setMenuState,
  activeMenuItem
}) {
  const { t } = useTranslation()

  const history = useHistory()
  const { pathname } = useLocation()
  const [forcedMenuItem, setForcedMenuItem] = useState(null)

  useEffect(() => {
    const handler = (event) => {
      setForcedMenuItem(event?.detail?.menuItem ?? null)
    }
    window.addEventListener('gpc-force-active-menu-item', handler)
    return () => window.removeEventListener('gpc-force-active-menu-item', handler)
  }, [])

  useEffect(() => {
    setForcedMenuItem(null)
  }, [pathname])

  const handleMenuToggle = useCallback((evt) => {
    evt.stopPropagation()
    setMenuState(currentState => ({
      opened: !currentState.opened,
      blocked: false
    }))
  }, [setMenuState])

  const handleBackHome = useCallback(() => {
    setMenuState({
      blocked: false,
      opened: false
    })
    history.push('/')
  }, [history, setMenuState])

  const menuOpened = _get(menuState, 'opened', false)

  const menuItems = useMemo(() => items.map((item, index) => {
    const currentMenuItem = _get(item, 'menuItem', false)
    const selected = forcedMenuItem ? forcedMenuItem === currentMenuItem : activeMenuItem === currentMenuItem
    const {
      subItems = [],
      path = ''
    } = item
    const key = `${path}-${index}`
    if (subItems.length) {
      return <ExpandableItem key={key} {...item} menuOpened={menuOpened} selected={selected} />
    }
    return <SingleIntem key={key} {...item} selected={selected} />
  }), [activeMenuItem, forcedMenuItem, items, menuOpened])

  return (
    items.length > 0 &&
      <List component="div" dataTestId="menuSideBar">
        <>
          <ListItem onClick={handleMenuToggle} key="toglleMenu" id="meuIcon">
            <ListItemIcon>{menuOpened ? <MenuOpenIcon /> : <MenuIcon />}</ListItemIcon>
          </ListItem>
          <StyledListItem onClick={handleBackHome} key="home" id="home" selected={pathname === '/' && !forcedMenuItem}>
            <ListItemIcon><HomeIcon /></ListItemIcon>
            <StyledListItemText>{t('menu.homepage')}</StyledListItemText>
          </StyledListItem>
          {menuItems}
        </>
      </List>
  )
}

ItemsList.propTypes = {
  items: PropTypes.array.isRequired,
  menuState: PropTypes.object.isRequired,
  setMenuState: PropTypes.func.isRequired,
  activeMenuItem: PropTypes.string
}

ItemsList.defaultProps = {
  activeMenuItem: ''
}

export default memo(ItemsList)
